import { SHADOW_HOST_ID } from '@iheartjane/reefer';
import { useEffect } from 'react';

import { Portal } from '@jane/shared/components';
import { postMessageToIframeParent } from '@jane/shared/util';

import { MONERIS_WIDGET_DIV_ID } from './useMoneris';

export const MonerisPortal = ({ onBackPress }: { onBackPress: () => void }) => {
  useEffect(() => {
    postMessageToIframeParent({ messageType: 'scrollToTop' });
    document.getElementById(SHADOW_HOST_ID)?.scrollIntoView();

    // We have to push a fake history state in order to intercept the back button
    window.history.pushState({}, '');
    const handleBackButton = () => {
      onBackPress();
    };
    window.addEventListener('popstate', handleBackButton);

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, []);

  return (
    <Portal>
      <div
        id={MONERIS_WIDGET_DIV_ID}
        style={{ zIndex: 'var(--layers-modal)' }}
      />
    </Portal>
  );
};
